// removed by extract-text-webpack-plugin
module.exports = {"footer":"_3O29ujeMQuiLZU0bq61j6r","top-row":"_2Y3PaddLf36C29cgiOKV5o","first":"RNRnWrHrAQvAeOsznzOux","content":"_3mljNXX0X_96ESVY2-8uj8","solutions":"_3Scw3DY357WHK2Etot4OGM","solutions-container":"KoWp9ijmRIZb2zsydieJo","about":"_1HWo06hDNAPPM9Q2c3WG9Q","newsletter":"_1jES0hlO4wDJuS7PbOKubU","input":"_1yPSSqrrlKWtr4uQ0Ds95J","error":"_3mhevV3-ljgjM85P0RXpDX","success":"_1R5qMLFBaMYio1IJsBhHQD","addon":"HSsT4icpSwCSuPqhQv6r0","bottom":"aMy6aIgAvmg8YPlhjNLvg","icons":"_1VWLtCNMLJjjalQN_H397j","icon":"_3-4ZC6enwFDHiO3aYKz9iK","created-by":"_1RECJazYd2Aw06Uk8gixAJ"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Footer/footer.module.styl
// module id = 246
// module chunks = 79611799117203 210842664985301